<template>
  <div class="alert alert-danger" role="alert">
    {{ errorMessage }}
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "ErrorComponent",

  computed: {
    ...mapGetters({
      errorMessage: 'getErrorMessage',
    }),
  }

};
</script>

<style scoped>
</style>